<template>
  <a-modal
    title="编辑配置"
    :width="1000"
    :visible="visible"
    @cancel="handleCancel"
    :maskClosable="false"
    :bodyStyle="{padding:0}"
  >
    <div style="height:70vh">
      <a-card :bordered="false" style="margin-top: 0px" v-if="currentRobotId">
        <div class="show_status_count">
          <span style="color:#1890ff">
            {{'已发送:'+finished_count}}
          </span> 
          <span>
            {{'未发送:'+unfinished_count}}
          </span> 
          <span style="color:#ff4d4f">
            {{'发送失败:'+failed_count}}
          </span>        
        </div>
        <s-table ref="table" rowKey="id" :columns="columns" :data="loadData" :scroll="{y:510 }">
          <span slot="nickname" slot-scope="record">
            <span>{{
              record.relation_to_member_list
                ? record.relation_to_member_list.nickname
                : record.relation_to_wx_friends_list.nickname
            }}</span>
          </span>
          <span slot="avatar" slot-scope="record">
            <a-avatar
              shape="square"
              :src="
                record.relation_to_member_list
                  ? record.relation_to_member_list.avatar
                  : record.relation_to_wx_friends_list.avatar
              "
            ></a-avatar>
          </span>
          <span slot="status" slot-scope="record">
            <a-badge status="warning" v-if="record.status === 0" text="未发送"></a-badge>
            <a-badge status="processing" v-else-if="record.status === 1" text="已发送"></a-badge>
            <a-badge status="error" v-else-if="record.status === 2" text="发送失败"></a-badge>
          </span>
        </s-table>
      </a-card>
    </div>
  </a-modal>
</template>

<script>
import { STable, ExceptionPage } from '@/components'
import GrouppushApi from '@/api/grouppush'
export default {
  components: {
    STable,
    ExceptionPage
  },
  data() {
    return {
      currentRobotId:'',
      visible:false,
      // 表头
      columns: [
        {
          title: 'ID',
          width: '80px',
          dataIndex: 'id',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '机器人ID',
          dataIndex: 'sub_id'
        },

        {
          title: '昵称',
          scopedSlots: { customRender: 'nickname' }
        },

        {
          title: '头像',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '发送',
          scopedSlots: { customRender: 'status' }
        },

        {
          title: '更新时间',
          dataIndex: 'update_time'
        }
      ],
      count:0,
      finished_count:0,
      unfinished_count:0,
      failed_count:0,
      loadData: parameter => {
        return GrouppushApi.getMemberList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        ).then(res=>{
          // console.log(res,'群发列表')
          this.count= res.params.count
          this.finished_count= res.params.finished_count
          this.unfinished_count= res.params.unfinished_count
          this.failed_count= res.params.failed_count
          return res.showList
        })
      },
    }
  },
  methods: {
    show(robot_id) {
      this.currentRobotId = robot_id
      // console.log(robot_id)
      this.$nextTick(()=>{
        this.$refs.table.refresh()
      })
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
  }
}
</script>
<style lang="less" scoped>
/deep/.ant-card-body{
  padding: 0 !important;
}
.show_status_count{
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
}
</style>
